import React from 'react';
export function Footer() {
  return <footer className="bg-[#051a11] text-white/60 py-12 text-center text-sm font-body border-t border-emerald-900" data-id="element-52">
      <div className="max-w-4xl mx-auto px-4" data-id="element-53">
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8" data-id="element-54">
          <a href="#" className="hover:text-gold transition-colors hover:underline" data-id="element-55">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold transition-colors hover:underline" data-id="element-56">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold transition-colors hover:underline" data-id="element-57">
            Aviso Legal
          </a>
        </div>

        <p className="mb-6" data-id="element-58">
          © {new Date().getFullYear()} Zeklo Club. Todos los derechos
          reservados.
        </p>

        <p className="text-xs max-w-2xl mx-auto text-white/40 leading-relaxed" data-id="element-59">
          Este producto no sustituye el consejo médico profesional. Los
          resultados pueden variar según la persona.
        </p>
      </div>
    </footer>;
}